<div class="table-container-wide">
  <div class="data-container">
    <div id="image-container" *ngIf="displayComponentTypeImage"><img [src]="componentTypeImageSource"></div>
    <div id="table-container">
      <mat-table [dataSource]="dataSource" class="mat-elevation-z8" id="additional-packaging-table" multiTemplateDataRows>
        <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column.text">
          <mat-header-cell *matHeaderCellDef>
            {{column.text}}
          </mat-header-cell>
          <mat-cell *matCellDef="let element; let i = index">
            <div *ngIf="column.id !== 'tracked' && column.id !== 'action'">
              {{element.getRawValue()[column.id]}}
            </div>
            <div *ngIf="column.id === 'tracked'">
              <mat-icon *ngIf="element.value.hasInternalTracking">track_changes</mat-icon>
            </div>
            <div *ngIf="column.id === 'action'">
              <ng-container *ngTemplateOutlet="actionColumn; context:{ row: element }"></ng-container>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <mat-cell *matCellDef="let element" [attr.colspan]="displayedColumnNames.length">
            <div class="expandable-element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
              <app-component-edit [packagingComponentType]="componentType" [packagingUnitTypeId]="packagingTypeId ?? -1"
                [canEditForm]="canEditForm" [isUserValidator]="isUserValidator" [isPreview]="isPreview" [isTracked]="isTracked"
                [allColors]="handler.allColors" [allMaterialFunctions]="handler.getMaterialFunctions(this.packagingTypeId, this.tableInfo.id)" [allManifestations]="handler.allManifestations"
                [manufacturingCountries]="handler.manufacturingCountries" [componentSubtypes]="componentPrototype.getComponentSubtypes()"
                [removabilityConditions]="componentPrototype.getRemovabilityConditions()" [baseForm]="element" [componentPrototype]="componentPrototype"
                [(relevantAnalysisTypes)]="relevantAnalysisTypes" [isDataExchangeSubRequest]="isDataExchangeSubRequest">
              </app-component-edit>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="expand">
          <mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <button mat-icon-button aria-label="expand row" (click)="onExpandClicked(element, $event)">
              @if (expandedElement === element) {
                <mat-icon>keyboard_arrow_up</mat-icon>
              } @else {
                <mat-icon>keyboard_arrow_down</mat-icon>
              }
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumnNames"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumnNames;"
          class="expandable-element-row"
          [class.expanded-row]="expandedElement === row"
          (click)="onExpandClicked(row, $event)">
        </mat-row>
        <mat-row *matRowDef="let row; columns: ['expandedDetail']" class="expandable-detail-row"></mat-row>
      </mat-table>
    </div>
  </div>
  <div id="buttons-container">
    <button class="add-button" (click)="addNewElement($event)" mat-raised-button color="primary"
      *ngIf="canEditForm" type="button" [disabled]="this.isSingleComponent && anyElements">
      <mat-icon>add</mat-icon>
      {{ 'component.' + tableInfo.label + 'AddNew' | transloco }}
    </button>
    <button class="add-button" (click)="openAddExistingDialog()" mat-raised-button color="primary" *ngIf="canEditForm"
      type="button" [disabled]="this.isSingleComponent && anyElements">
      <mat-icon>menu_open</mat-icon>
      {{ 'component.' + tableInfo.label + 'AddExisting' | transloco }}
    </button>
  </div>
</div>

<ng-template #actionColumn let-row="row">
  <button mat-icon-button (click)="openDeleteDialog(row, $event)" color="primary" *ngIf="canEditForm" type="button">
    <mat-icon>delete_forever</mat-icon>
  </button>
  <button mat-icon-button (click)="saveComponent(row, $event)" color="primary" *ngIf="canEditForm" type="button">
    <mat-icon>save_alt</mat-icon>
  </button>
  <button mat-icon-button (click)="removeInternalTracking(row, $event)" color="primary"
          *ngIf="canEditForm && row.controls.hasInternalTracking.value"
          type="button" matTooltip="{{ 'component.tooltips.removeInternalTracking' | transloco }}">
          <mat-icon>content_cut</mat-icon>
        </button>
  <button mat-icon-button color="primary" (click)="openHeaderInfo(row, $event)">
    <mat-icon>attachment</mat-icon>
  </button>
</ng-template>
